import { Checkbox, usePopoverContext, Calendar, DateRangePicker } from '@fox/atoms';
import React, { ChangeEvent, useEffect, useState } from 'react';
import styled from 'styled-components';
import { FilterProps } from '../filter-props';

// Given display: flex with gap is only recently supported, this makes a column that emulates this using css grid - who knew css-grid would one-up flex?
const FlexGridColumn = styled.div`
	margin: 1em;
	display: grid;
	grid-template-columns: 1fr;
	gap: 1em;
`;

export type DateRangeFilterProps = {
	gte: Date;
	lte?: Date;
};

export function DateRangeFilter({ value, updateFilter }: FilterProps<DateRangeFilterProps>) {
	return (
		<DateRangePicker
			hideClearIcon
			value={value && value.gte && value.lte ? [value.gte, value.lte] : null}
			onChange={c => updateFilter({ gte: Array.isArray(c) ? c[0] : c, lte: Array.isArray(c) ? c[1] : c })}
		/>
	);
}

export function UpcomingDateFilter({ value, updateFilter }: FilterProps<DateRangeFilterProps>) {
	const [upcoming, setUpcoming] = useState(false);
	const { remeasure } = usePopoverContext();

	function updateUpcoming(e: ChangeEvent<HTMLInputElement>) {
		const checked = e.target.checked;

		if (checked) {
			updateFilter({ gte: new Date() });
		} else {
			updateFilter(undefined);
		}
		setUpcoming(checked);
	}

	useEffect(() => {
		remeasure();
	}, [remeasure, upcoming]);

	return (
		<FlexGridColumn>
			<label>
				{' '}
				<Checkbox onChange={updateUpcoming} /> Only show upcoming
			</label>

			{!upcoming && (
				<Calendar
					selectRange={true}
					value={value && value.gte && value.lte ? [value.gte, value.lte] : null}
					onChange={c => updateFilter({ gte: Array.isArray(c) ? c[0] : c, lte: Array.isArray(c) ? c[1] : c })}
				/>
			)}
		</FlexGridColumn>
	);
}
